  function adjustMenuDrawerHeight() {
    var windowHeight = window.innerHeight;
    
    var scrollPosition = window.scrollY;

    const utilityBarGrid = document.querySelector('.utility-bar__grid');
    const height = utilityBarGrid.offsetHeight;
    
    var drawerHeight = windowHeight;
    if (scrollPosition <= height) {
        drawerHeight = windowHeight;
    }

    var drawer = document.getElementById('menu-drawer');
    drawer.style.height = drawerHeight + 'px';
  }

  window.addEventListener('load', adjustMenuDrawerHeight);
  window.addEventListener('resize', adjustMenuDrawerHeight);
  window.addEventListener('scroll', adjustMenuDrawerHeight);